import { useEffect } from "react";
import { useApiPost } from "../../hooks";

const EmmaSandBox = () => {
  const { dispatchPost } = useApiPost(
    `api/Email/SendEmail?to=emma@experiencetrue.com`
  );

  useEffect(() => {
    dispatchPost();
  }, []);

  return <></>;
};

export default EmmaSandBox;
